import { Fancybox } from "@fancyapps/ui";
import { getFileType } from "./fileType";

export const openFancybox = (url) => {
  const type = getFileType(url);

  if (type === "image") {
    Fancybox.show([
      {
        src: url,
        type: "image",
      },
    ]);
    return;
  }

  if (type === "pdf") {
    Fancybox.show([
      {
        src: url,
        type: "iframe",
      },
    ]);
    return;
  }

  // Fallback: open in new tab
  window.open(url, "_blank");
};
